import React, { useState } from "react";
import BarekamInputMultilingual from "../../../../../../pages/components/input-multilingual/barekam-input-multilingual";
import { ProductCategoryModel } from "../../../../../../redux/reducers/static-data.reducers";
import { DialogContent, Grid } from "@mui/material";
import {
  Message,
  MessageSections,
} from "../../../../../../pages/components/message/message";
import { StandardDialogFooter } from "../../../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import { AxiosError } from "axios";
import { mapValidationErrors } from "../../../../../../pages/user/settings/personal-info/personal-info.service";
import BarekamInput from "../../../../../../pages/components/input";
import { getMessage } from "../../../../../../pages/shared/helper-functions";
import { useAppSelector } from "../../../../../../redux/store";
import productCategoriesService from "../../../../../../services/product-categories.service";

const EditProductCategory = ({
  productCategoryData,
  onCancel,
}: {
  productCategoryData: ProductCategoryModel;
  onCancel: () => void;
}) => {
  const [modifiedProductCategory, setModifiedProductCategory] =
    useState(productCategoryData);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const { messageCache, languageId } = useAppSelector(
    (state) => state.messagesReducer,
  );

  function handleChange(
    field: "name" | "description" | "code" | "meta_keys",
    value: any,
  ) {
    setModifiedProductCategory((prevState) => {
      prevState[field] = value;

      return { ...prevState };
    });
  }

  function validateData() {
    const errors = {} as { [key: string]: string };

    if (
      !modifiedProductCategory.name ||
      Object.keys(modifiedProductCategory.name).length < 1
    ) {
      errors["name"] = "required";
    }
    if (!modifiedProductCategory.code) {
      errors["code"] = "required";
    }
    return errors;
  }

  function handleSave() {
    const errors = validateData();
    setErrors(errors);

    if (Object.keys(errors).length === 0) {
      if (modifiedProductCategory.productCategoryId) {
        productCategoriesService
          .editProductCategory(
            modifiedProductCategory.productCategoryId,
            modifiedProductCategory,
          )
          .then(() => onCancel())
          .catch((reason) => {
            if (reason instanceof AxiosError) {
              setErrors(mapValidationErrors(reason));
            }
          });
      } else {
        productCategoriesService
          .createProductCategory(modifiedProductCategory)
          .then(() => onCancel())
          .catch((reason) => {
            if (reason instanceof AxiosError) {
              setErrors(mapValidationErrors(reason));
            }
          });
      }
    }
  }

  return (
    <>
      <DialogContent>
        <Grid container rowSpacing={"1rem"} columnSpacing={"1rem"}>
          <BarekamInputMultilingual
            multilingualText={modifiedProductCategory.name || {}}
            labelKey={"name"}
            field={"name"}
            onChange={(name) => handleChange("name", name)}
            errors={errors}
          />

          <BarekamInputMultilingual
            multilingualText={modifiedProductCategory.description || {}}
            labelKey={"description"}
            field={"description"}
            onChange={(description) => handleChange("description", description)}
            errors={errors}
          />

          <Grid item xs={12}>
            <BarekamInput
              key={"code"}
              customInputVariant={"standard"}
              placeholder={getMessage(
                "product_category_code",
                MessageSections.LOGIN,
                messageCache,
                languageId,
              )}
              value={modifiedProductCategory.code}
              onChange={(value) => handleChange("code", value.target.value)}
              error={!!errors["code"]}
              errorMessage={
                errors["code"] &&
                getMessage(
                  errors["code"],
                  MessageSections.MAIN,
                  messageCache,
                  languageId,
                )
              }
              width={"100%"}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <BarekamInput
              key={"meta_keys"}
              customInputVariant={"standard"}
              placeholder={getMessage(
                "product_category_meta_keys",
                MessageSections.LOGIN,
                messageCache,
                languageId,
              )}
              value={modifiedProductCategory.meta_keys}
              onChange={(value) =>
                handleChange("meta_keys", value.target.value)
              }
              error={!!errors["meta_keys"]}
              errorMessage={
                errors["meta_keys"] &&
                getMessage(
                  errors["meta_keys"],
                  MessageSections.MAIN,
                  messageCache,
                  languageId,
                )
              }
              width={"100%"}
              required
            />
          </Grid>
        </Grid>
      </DialogContent>

      <StandardDialogFooter
        onCancel={() => onCancel()}
        onSave={() => handleSave()}
        saveLabel={
          <Message messageKey={"save"} sectionId={MessageSections.MAIN} />
        }
      />
    </>
  );
};

export default EditProductCategory;
